'use strict';
import React, { Component } from 'react';
import ProcessManager from '../../../Common/Managers/ProcessManager';
/**
 * 
 */
class TableRowDesplegable extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data
        };

        this.rutearNuevaInstanciaParametro = this.rutearNuevaInstanciaParametro.bind(this);
        this.eliminarInstanciaParametro = this.eliminarInstanciaParametro.bind(this);
    }

    rutearNuevaInstanciaParametro() {
        const { parametro } = this.props;

        const objEntidadInstancia = {
            entidadInstanciaId: parametro[0].EntidadInstanciaId,
            rutearEdicionInstancia: true,
            rutaEdicionInstancia: ProcessManager.GetNextStep("NuevaInstanciaParametro", "ROUTE_TO_NUEVA_INSTANCIA_PARAMETRO")
        }

        this.props.setearEntidadInstancia(objEntidadInstancia);
    }

    eliminarInstanciaParametro() {

    }

    render() {
        const { filaEnModoDesplegable, mostrarFilaEnModoDesplegable, parametro, parametroEquivalencia, soloLectura } = this.props;

        let atributosClaveValor = [];
        let atributosClaveValorParametro = [];

        atributosClaveValor = parametro.filter((row) => row.EstaVisible).map((rowClave, index) => {
            let valorAMostrar = (rowClave.DescripcionEr || rowClave.Valor);

            /*Se utiliza el valor "0" para designar al valor "Todos/as" - AD17-1349 */
            if (rowClave.TipoCodigo == "SELECT" && valorAMostrar == "0")
                valorAMostrar = rowClave.GeneroEntidadRelacionada == 1 ? "Todos" : "Todas";

            if(rowClave.TipoCodigo == "CHECK"){
                valorAMostrar = rowClave.Valor == "1" ? "Si" : "No";
            }
            valorAMostrar = ((valorAMostrar == "" || valorAMostrar == undefined) ? "No posee valor" : valorAMostrar);

            return (
                <div key={rowClave.Id} className="col-xs-12">
                    <div>
                        <label className="label-grey-12"><strong>{rowClave.Descripcion}</strong></label>
                    </div>
                    <div>
                        <label className="label-black-14-bold">{valorAMostrar}</label>
                    </div>
                </div>
            );
        });

        atributosClaveValorParametro = parametroEquivalencia.map((rowClave, index) => {
            return (
                <div key={rowClave.CODIGO || rowClave.VALOR} className="col-xs-12">
                    <div>
                        <label className="label-grey-dark-14 right-separator-xxs">{rowClave.CODIGO}:</label>
                        <label className="label-black-14-bold">{rowClave.VALOR}</label>
                    </div>
                </div>
            )
        });

        let esActivo = parametro && parametro[0] && parametro[0].Activo;
        return (
            <tr>
                <td colSpan="4" className={((filaEnModoDesplegable == false) ? "td-tarjetas-no-pad-border" : "td-tarjetas-no-pad")}>
                    <div className={"slider-tarjetas" + ((filaEnModoDesplegable == false) ? " closed" : "")}>

                        
                        <div className="text-right top-separator-xxs">
                            {!soloLectura ?
                                <a id="rutearInstancia" className="clickable none-text-decoration glyphicon glyphicon-pencil grey-dark"
                                    onClick={() => this.rutearNuevaInstanciaParametro()}></a>
                            :
                            null
                            }
                            <label>&nbsp;&nbsp;&nbsp;</label>
                            
                        </div>

                        {atributosClaveValor}
                        {parametroEquivalencia.length > 0 &&
                            <div>
                                <div className="col-xs-12 top-separator-xs">
                                    <label className="label-grey-light-16"><strong>Equivalencias</strong></label>
                                    <hr className="separator-line separator-light" />
                                </div>
                                {atributosClaveValorParametro}
                            </div>
                        }
                    </div>
                </td>
            </tr>
        );
    }
}

export default TableRowDesplegable